import { render, staticRenderFns } from "./CapitalRow.vue?vue&type=template&id=6f9ebb72&scoped=true&"
import script from "./CapitalRow.vue?vue&type=script&lang=js&"
export * from "./CapitalRow.vue?vue&type=script&lang=js&"
import style0 from "./CapitalRow.vue?vue&type=style&index=0&id=6f9ebb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ebb72",
  null
  
)

export default component.exports